export const EVENT_CATEGORIES = [
  'Cultes & Messe',
  'Conférences',
  'Concerts',
  'Formations & Enseignements',
  'Jeunesse & Activités',
  'Prières',
  'Spécial',
  'Autre',
];
